import { defineMessages } from 'react-intl';

export default defineMessages({
  removePatient: 'Dane klienta w trakcie usuwania',
});
